export const OVERLAY_DURATION_MS = 1500
